// extracted by mini-css-extract-plugin
export default {"your_rd":"Ru","title":"Su","subtitle":"Tu","rd_bio_wrapper":"Uu","rd_text_mobile":"Vu","rd_bio":"Wu","img":"Xu","rd_info":"Yu","rd_name":"Zu","rd_stat":"av","rd_text":"bv","btn_mobile":"cv"};
    if(module.hot) {
      // 1713996746542
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  